
import AppLayoutLinks from '@/views/layouts/AppLayoutLinks.vue'
export default {
  name: 'DefaultLayout',
  components: {
    AppLayoutLinks,
  },
}
